import React from 'react';
import PropTypes from 'prop-types';
import { LoadingWrapper, LoadingImage } from './Loading.style';

const Loading = ({ pixelWidth, strokeColor, horizontalAlign }) => {
  const size = pixelWidth * 2.5;
  const radius = size / 2;
  const stroke = 5;
  const speed = '1500';
  return (
    <LoadingWrapper
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      preserveAspectRatio="xMidYMid"
      horizontalAlign={horizontalAlign}
    >
      <LoadingImage pixelWidth={pixelWidth} foreground={strokeColor}>
        <rect x="0" y="0" width={size} height={size} fill="none" />
        <circle
          cx={radius}
          cy={radius}
          r={pixelWidth}
          fill="none"
          strokeDasharray={`${size * 2} ${radius}`}
          strokeWidth={stroke}
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            values={`0 ${radius} ${radius};180 ${radius} ${radius};360 ${radius} ${radius};`}
            keyTimes="0;0.5;1"
            dur={speed}
            repeatCount="indefinite"
            begin="0s"
          />
        </circle>
      </LoadingImage>
    </LoadingWrapper>
  );
};

Loading.propTypes = {
  pixelWidth: PropTypes.number,
  horizontalAlign: PropTypes.string,
  strokeColor: PropTypes.string,
};

Loading.defaultProps = {
  pixelWidth: 64,
  horizontalAlign: 'center',
  strokeColor: '#0A1B36',
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js